<template>
  <div class="map" :class="{ 'showInfo': isMobile }">
    <header v-if="!isMobile">
      <div class="title" v-if="!isMobile">
        <router-link to="/">地图搜租房</router-link>
        <el-dropdown>
          <span class="el-dropdown-link location">
            <i class="el-icon-location"></i>
            {{ location }}
            <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="el-dropdown-menu">
            <el-dropdown-item v-for="item in cities" :key="item">
              <span @click="cityLocation(item)" class="link-to">{{ item }}</span>
              <!--              <a href="javascript:;"-->
              <!--                 target="_blank"-->
              <!--                 @click="cityLocation(item)"-->
              <!--                 class="link-to">{{item}}</a>-->
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="search-wrap">
        <div class="key-word" v-if="!isMyCollections">
          <div class="keyword-tag">
            <el-tag class="tag" :key="tag" v-for="tag in keywordArr" closable :disable-transitions="false"
              @close="removeKeyword(tag)">{{ tag }}</el-tag>
          </div>
          <el-input class="keyword-tag-input" v-model="keywordTag" ref="saveTagInput" size="small" v-if="inputVisible"
            @keyup.enter.native="keywordConfirm" @blur="keywordConfirm" placeholder="搜索关键字" :maxlength="50"></el-input>
          <el-button v-if="!inputVisible && keywordArr.length <= 6" class="button-new-tag" size="small"
            @click="showInput">+ 关键词</el-button>
        </div>
        <el-button v-if="!isMyCollections" type="primary" class="search-btn" size="small" @click="refresh"
          :loading="loading">搜索</el-button>
        <el-checkbox v-model="isMyCollections" v-if="user" :disabled="loading" style="margin-left: 10px;"
          @change="updateMyCollectionState">我的收藏</el-checkbox>
      </div>
      <div class="carousel-wrap">
      <el-carousel trigger="click" height="20px" class="carousel" indicator-position="none" arrow="never">
        <el-carousel-item class="carousel-item-center">
          <a
            href="https://chat.r2049.cn/user/login"
            target="_blank"
            class="carousel-item"
            >GPT2077：无需科学上网，畅享最强AI~</a
          >
        </el-carousel-item>
        <el-carousel-item  class="carousel-item-center">
          <a
            href="https://pdf.r2049.cn/?lang=zh_CN"
            target="_blank"
            class="carousel-item"
            >R2049 PDF：免安装在线PDF工具集~</a
          >
        </el-carousel-item>
        <el-carousel-item class="carousel-item-center">
          <a
            href="https://mp.weixin.qq.com/s/4nC2zZm2a6Tn4LL7H-oC8w"
            target="_blank"
            class="carousel-item"
            >关注【人生删除指南】微信公众号获取租房小程序。</a
          >
        </el-carousel-item>
        <el-carousel-item class="carousel-item-center">
          <a
            href="https://chat.r2049.cn/user/login?inviteCode=WDMUX2NN"
            target="_blank"
            class="carousel-item"
            >GPT2077：注册直送50W Token额度（GPT4、3.5模型通用）。</a
          >
        </el-carousel-item>
        <el-carousel-item class="carousel-item-center">
          <a
            href="https://wj.qq.com/s2/3264919/3fdd"
            target="_blank"
            class="carousel-item"
            >合租需谨慎，群租有风险，长租公寓多当心。</a
          >
        </el-carousel-item>
        <el-carousel-item class="carousel-item-center">
          <a
            href="https://wj.qq.com/s2/3264919/3fdd"
            target="_blank"
            class="carousel-item"
            >特此声明:房源信息来自网络，请自行鉴别。</a
          >
        </el-carousel-item>
      </el-carousel>
      </div>
    </header>
    <div class="filter-wrap" v-if="!isMobile && !isMyCollections">
      <ul>
        <li>
          <span>房源类型：</span>
          <div>
            <el-select v-model="form.rentType" @change="refresh" placeholder="请选择房源类型" size="mini" style="width: 100%">
              <el-option :key="item.value" v-for="item in rentTypeArr" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </div>
          <span>价位：</span>
          <div>
            <el-col :span="11">
              <el-input @change="refresh" v-model="form.fromPrice" size="mini" type="number" placeholder="最低价"
                :maxlength="8"></el-input>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-input @change="refresh" v-model="form.toPrice" size="mini" type="number" placeholder="最高价"
                :maxlength="8"></el-input>
            </el-col>
          </div>
          <span>房源：</span>
          <div class="displaySource">
            <span :class="{ active: !$route.query.source }" @click="selectSource('')">全部</span>
            <span :class="{ active: item.source === $route.query.source }" v-for="item in source " :key="item.source"
              @click="selectSource(item.source)">{{ item.displaySource }}
            </span>
            <!--<el-select @change="refresh" v-model="form.source" size="mini" placeholder="请选择房源"-->
            <!--filterable>-->
            <!--&lt;!&ndash;<el-option label="全部" value=""></el-option>&ndash;&gt;-->
            <!--<el-option-->
            <!--v-for="item in otherSource"-->
            <!--:label="item.displaySource"-->
            <!--:value="item.source"-->
            <!--:key="item.id"-->
            <!--&gt;-->
            <!--</el-option>-->
            <!--</el-select>-->
          </div>
        </li>
        <li>
          <el-button type="info" size="mini" @click="resetFilter">重置</el-button>
        </li>
      </ul>
    </div>
    <div class="map-content" v-loading="loading">
      <div v-if="!isMobile" class="map-house-list">
        <!--<span class="toggleHouseList" @click="toggleHouseListUp = !toggleHouseListUp">{{toggleHouseListUp ? '收起' : '展开'}}</span>-->
        <el-collapse-transition>
          <house-list :loading="loading" height="100%" v-show="toggleHouseListUp" :house-list="mapHouseList"
            @click="houseListClick"></house-list>
        </el-collapse-transition>
      </div>
      <div class="container-wrap">
        <template v-if="!inMap">
          <div id="panel" v-show="transferWays" :class="{ 'slide-up': toggleUp, 'is-mobile': isMobile }">
            <!--<span class="panel-handle" @click="toggleUp = !toggleUp">{{!toggleUp ? '收起' : '展开'}}</span>-->
          </div>
          <span @click="whereAmI" class="where-am-i" :class="{ 'is-mobile': isMobile }">
            <i class="el-icon-location"></i>
            我在哪
          </span>
        </template>



        <template v-if="!isMobile && !isMyCollections">

          <el-collapse class="collapseCard">
            <!-- <h4>出行到达圈查询</h4> -->
            <el-collapse-item title="出行导航(点击展开)">
              <div class="card">
                <div class="card-item">
                  <span class="card-name">上班地点</span>
                  <el-input id="keyword" class="card-value" size="mini" type="text" placeholder="请输入内容"
                    v-model="keyword" clearable></el-input>
                </div>
                <div class="card-item">
                  <span class="card-name">时长(分钟)</span>
                  <el-slider class="card-value" :min="1" :max="60" v-model="times" size="mini"></el-slider>
                  <span class="card-times">{{ times }}</span>
                </div>
                <div class="card-item">
                  <span class="card-name">出行方式</span>
                  <el-select v-model="waysMethod" placeholder="请选择出行方式" class="card-value" size="mini">
                    <el-option label="地铁+公交" value=""></el-option>
                    <el-option label="地铁" value="SUBWAY"></el-option>
                    <el-option label="公交" value="BUS"></el-option>
                  </el-select>
                </div>
                <div class="card-item btn">
                  <el-button type="primary" size="mini" @click="search" :loading="searching">查询</el-button>
                  <el-button type="info" size="mini" :loading="searching" @click="next">下一页</el-button>
                  <!--<el-button size="mini">清空</el-button>-->
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
          <span class="highlight-text">
            特此声明:房源信息来自网络，请自行鉴别。合租需谨慎，群租有风险，长租公寓多当心。地图首次载入较慢。
            <a href="https://wj.qq.com/s/2953926/aabe" target="_blank" class="do-more-better">帮我们做得更好?</a>
          >
          </span>
          <!--<div class="map-house-list">-->
          <!--<span class="toggleHouseList" @click="toggleHouseListUp = !toggleHouseListUp">{{toggleHouseListUp ? '收起' : '展开'}}</span>-->
          <!--<el-collapse-transition>-->
          <!--<house-list v-show="toggleHouseListUp" :house-list="mapHouseList" @click="houseListClick"-->
          <!--v-if="mapHouseList && mapHouseList.length"></house-list>-->

          <!--</el-collapse-transition>-->
          <!--</div>-->
        </template>
        <div class="container" id="map-container"></div>
      </div>
      <template v-if="isMobile">
        <div class="mobile-type" :class="{ 'in-map': inMap }">
          <span @click="toMap" :class="{ active: mobileType !== 'list' }">地图模式</span>
          <span @click="toList" :class="{ active: mobileType === 'list' }">列表模式</span>
        </div>
        <template v-if="!inMap">
          <div class="filter">
            <div class="filter-item">
              <span>上班地点:</span>
              <el-input id="keyword" class="card-value" size="mini" placeholder="请输入内容" v-model="keyword"
                clearable></el-input>
            </div>
            <div class="filter-item">
              <el-button type="primary" size="mini" :loading="searching" @click="next">下一页</el-button>
              <!--<el-button icon="el-icon-tickets" size="mini" type="text" @click="toList"-->
              <!--class="to-list"></el-button>-->
            </div>
          </div>
          <div class="mobile-bg" v-if="makerInfo" @click="handleMobileBg">
            <div class="content">
              <section>
                <span class="content-name">房源:</span>
                <a :href="`/app/house-map#/detail/${makerInfo.id}`" target="_blank" class="content-value">{{ makerInfo.title }}</a>
              </section>
              <section v-if="makerInfo.displayMoney">
                <span class="content-value">{{ makerInfo.displayMoney }}</span>
              </section>
              <section>
                <el-tag size="mini" :type="tagType(makerInfo)">{{ tagText(makerInfo) }}</el-tag>
              </section>
              <section>
                <span class="content-value">{{ makerInfo.sourceContent }}</span>
              </section>
              <section v-if="makerInfo.pictures && makerInfo.pictures.length">
                <span class="content-name btn" @click="preview(makerInfo)">
                  <i class="el-icon-picture"></i>查看图片
                </span>
              </section>
              <section>
                <span class="content-name btn" @click="collect(makerInfo)">
                  <i class="el-icon-star-on"></i>收藏
                </span>
              </section>
              <section>
                <span class="content-name btn" @click="navTo(makerInfo)">
                  <i class="el-icon-location"></i>开始导航
                </span>
              </section>
            </div>
          </div>
        </template>
      </template>
    </div>
    <component v-if="view" :is="view"></component>
  </div>
</template>
<style scoped lang="scss">
.location {
  cursor: pointer;
}

.filter-wrap {
  min-height: 40px;
  display: flex;
  border-bottom: 1px solid #efefef;
  border-top: 1px solid #efefef;
  padding: 0 10px;

  .displaySource {
    display: flex;
    width: auto;
    align-items: center;

    span {
      cursor: pointer;
      transition: color 0.3s;

      &.active,
      &:hover {
        color: #0d87f4;
      }
    }
  }

  .line {
    line-height: 28px;
    text-align: center;
  }

  ul {
    display: flex;
    width: 100%;
  }

  li {
    flex: auto;
    border-right: 1px solid #efefef;
    display: flex;
    font-size: 12px;
    align-items: center;
    padding: 0 8px;

    span {
      margin-right: 8px;
    }

    >div {
      width: 200px;
      margin-right: 10px;
    }
  }
}

.keyword-tag {
  .tag {
    margin-right: 10px;
  }
}

.button-new-tag {
  height: 32px;
}

.keyword-tag-input {
  width: 120px;
}

.link-to {
  color: #333;
  display: block;
}

header {
  min-height: 80px;
  display: flex;
  align-items: center;
  padding: 10px;

  .title {
    border-right: 1px solid #efefef;
    padding-right: 20px;
    margin-right: 20px;

    a {
      color: #0e90d2;
      font-size: 28px;
      font-weight: 600;
      letter-spacing: 7px;
      transition: all 0.5s;

      &:hover {
        color: #095f8a;
      }
    }
  }
}

.carousel-wrap {
  // display: flex;
  // align-items: center;
  width:400px;
  .carousel-item-center{
    display: flex;
    align-items: center;
    justify-content: center;
    .carousel-item {
    display: inline-flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    vertical-align: middle;
    position: relative;
    text-decoration: none;
    outline: none;
    cursor: pointer;
    padding: 0;
    font-size: 14px;
    font-weight: 500;
    color:#0e90d2
  }
  }
}

.search-wrap {
  height: 44px;
  display: flex;
  align-items: center;

  .search-btn {
    margin-left: 20px;
  }

  .key-word {
    font-size: 14px;
    display: flex;
  }
}

.container-wrap {
  position: relative;
  flex: auto;
}

.to-list {
  color: #fff;
  font-size: 18px;
}

.highlight-text {
  position: absolute;
  color: red;
  left: 83px;
  top: 2px;
  font-weight: bold;
  z-index: 40;
}

.icon-tips {
  position: absolute;
  right: 20px;
  top: 30px;
  z-index: 66;

  li {
    margin-bottom: 10px;

    &:not(.btn) {
      pointer-events: none;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
    }

    &.btn {
      margin-bottom: 20px;
    }
  }

  span {
    margin-left: 10px;
    color: #333;
  }
}
.el-dropdown-menu {  
  max-height: 400px;  
  overflow-y: auto;  
}

.right {
  width: 0px;
  transition: all 0.3s;
  overflow: hidden;
  background: #333;
  padding: 0px;
  opacity: 0;

  &.show-right {
    opacity: 1;
    width: 300px;
    padding: 15px;
  }

  section {
    background: rgba(119, 136, 153, 0.8);
    padding: 10px;
    border-radius: 3px;
    color: #ccc;
    margin-bottom: 10px;

    .el-icon-circle-close {
      cursor: pointer;
    }

    p {
      margin: 0;
    }

    .nav {
      display: block;
      color: #ccc;
    }

    .sub-title {
      margin-bottom: 5px;
    }

    .text {
      color: #999;
    }

    .keyword-clean {
      display: none;
    }

    .clean {
      .el-input__suffix {
        display: block;
      }
    }

    .to {
      display: block;
      color: #ccc;
      transition: color 0.2s;

      &:hover {
        color: #a7a4a4;
      }
    }
  }

  .link {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    text-align: left;

    .to {
      flex: auto;

      &:nth-of-type(2n) {
        margin-left: 20px;
      }
    }
  }

  .commuting {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .text {
      margin-bottom: 0;
    }
  }
}

.collapseCard {
  display: flex;
  flex-direction: column;
  word-break: break-word;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
  border-radius: 5px;
  position: absolute;
  left: 80px;
  top: 40px;
  z-index: 30;
  padding: 12px;

}

.card {
  display: flex;
  flex-direction: column;
  word-break: break-word;
  background: #fff;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
  // border-radius: 5px;
  // position: absolute;
  // left: 80px;
  // top: 40px;
  // z-index: 30;
  padding: 12px;

  h4 {
    color: grey;
    font-size: 13px;
    font-weight: normal;
  }

  .card-item {
    display: flex;
    font-size: 12px;
    align-items: center;

    &.btn {
      margin-top: 10px;
      text-align: center;
      justify-content: center;
    }

    .card-times {
      margin-left: 10px;
    }

    .card-value {
      flex: auto;
    }

    .card-name {
      min-width: 70px;
    }
  }
}

.mobile-type {
  height: 40px;
  position: fixed;
  z-index: 41;
  left: 0;
  width: 100%;
  background: #fff;
  top: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;

  &.in-map {
    z-index: 2555;
  }

  span {
    font-size: 12px;
    flex: 1;

    &.active {
      color: #409eff;
    }

    &:first-of-type {
      border-right: 1px solid #eee;
    }
  }
}

.filter {
  position: fixed;
  z-index: 40;
  left: 0;
  top: 40px;
  width: 100%;
  background: rgba(0, 0, 0, 0.7);
  padding: 10px;
  display: flex;
  align-items: center;

  .filter-item {
    display: flex;
    flex-direction: row;
    font-size: 12px;
    align-items: center;

    &:nth-of-type(2n) {
      margin-left: 5px;
    }

    span {
      color: #fff;
      width: 70px;
    }
  }
}

.mobile-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
  left: 0;
  top: 0;

  .content {
    padding: 10px;
    height: 100%;
    max-height: 100%;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
    width: 45%;
    position: absolute;
    right: 0;
    top: 0;
    background: #fff;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;

    .content-name {
      &.btn {
        display: block;
      }
    }

    section {
      padding: 15px 0;
      border-bottom: 1px solid #eee;
      font-size: 14px;
    }
  }
}

.where-am-i {
  position: fixed;
  z-index: 60;
  right: 20px;
  bottom: 20px;
  text-align: center;
  font-size: 12px;
  background: #fff;
  border-radius: 4px;
  padding: 10px;
  cursor: pointer;

  &.is-mobile {
    right: 18%;
  }

  i {
    display: block;
  }
}

.map-house-list {
  z-index: 67;
  max-height: 100%;
  overflow: auto;
  width: 300px;
  top: 40px;
  right: 178px;
  background: #fff;
  border-radius: 5px;
  height: 100%;

  .toggleHouseList {
    cursor: pointer;
    display: block;
    padding: 2px 10px;
    color: #fff;
    background: #409eff;
  }
}
</style>
<style lang="scss">
.map {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .map-content {
    flex: auto;
    width: 100%;
    display: flex;
    height: 100%;
  }

  &.showInfo {
    padding-top: 30px;

    .mobile-type {
      top: 27px;
    }

    .filter {
      top: 67px;
    }

    .house-list.in-map {
      margin-top: 67px;
    }
  }

  .do-more-better {
    text-decoration: underline;
    font-size: #333;
  }

  .container {
    height: 100%;
    flex: auto;
  }

  .marker-info {
    i {
      margin-right: 4px;
    }
  }

  .marker-link {
    display: block;
    font-size: 12px;
    color: #0e90d2;
    text-decoration: none;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  .amap-icon {
    img {
      width: 19px;
    }
  }

  .amap-marker .marker-route {
    position: absolute;
    width: 40px;
    height: 44px;
    color: #e90000;
    background: url(https://webapi.amap.com/theme/v1.3/images/newpc/poi-1.png) no-repeat;
    cursor: pointer;
  }

  .amap-marker .marker-marker-bus-from {
    background-position: -334px -180px;
  }

  #panel {
    position: absolute;
    background-color: white;
    z-index: 99;
    max-height: 63%;
    overflow-y: auto;
    top: 254px;
    left: 5%;
    width: 250px;
    border: solid 1px silver;
    -webkit-overflow-scrolling: touch;
    transition: all 0.3s;

    &.is-mobile {
      top: 100px;
    }

    .panel-handle {
      display: block;
      padding: 0 10px;
      cursor: pointer;
      background: #f56c6c;
      color: #fff;
    }

    &.slide-up {
      overflow: hidden;
      max-height: 25px;
    }

    &:empty {
      display: none;
    }
  }
}
</style>
<script>
import Vue from "vue";
import userInfo from "../components/user-info";
import HouseList from "./../components/house-list";
import { tagText, tagType } from "../components/house-type";

const asyncComponent = require("../components/async-component.tsx").default;

export default {
  components: {
    HouseList,
  },
  data() {
    return {
      isMyCollections: false,
      form: {
        rentType: undefined,
        fromPrice: undefined,
        toPrice: undefined,
        source: undefined,
      },
      inputVisible: false,
      rentTypeArr: [
        {
          label: "全部",
          value: undefined,
        },
        {
          label: "未知",
          value: 0,
        },
        {
          label: "合租",
          value: 1,
        },
        {
          label: "单间",
          value: 2,
        },
        {
          label: "整套出租",
          value: 3,
        },
        {
          label: "公寓",
          value: 4,
        },
      ],
      source: [],
      keywordTag: "",
      keywordArr: [],
      cities: [],
      toggleHouseListUp: true,
      mapHouseList: [],
      houseList: [],
      zoom: 15,
      info: undefined,
      markers: [],
      loading: true,
      cityName: "",
      myPosition: undefined,
      transferFn: undefined,
      iconTips: [
        {
          src: require("./../images/Blue.png"),
          text: "0-1000",
        },
        {
          src: require("./../images/PaleGreen.png"),
          text: "1000-2000",
        },
        {
          src: require("./../images/LightGreen.png"),
          text: "2000-3000",
        },
        {
          src: require("./../images/PaleYellow.png"),
          text: "3000-4000",
        },
        {
          src: require("./../images/OrangeYellow.png"),
          text: "4000-5000",
        },
        {
          src: require("./../images/PaleRed.png"),
          text: "5000-6000",
        },
        {
          src: require("./../images/Red.png"),
          text: "6000-7000",
        },
        {
          src: require("./../images/Pink.png"),
          text: "7000-8000",
        },
        {
          src: require("./../images/Violet.png"),
          text: "8000-9000",
        },
        {
          src: require("./../images/Black.png"),
          text: "9000+",
        },
      ],
      activeCityName: "",
      showRight: true,
      inMap: false,
      keyword: "",
      commuting: 1,
      transferWays: false,
      toggleUp: false,
      times: 60,
      waysMethod: "",
      map: undefined,
      lnglat: undefined,
      arrivalRange: undefined,
      polygons: [],
      positionPicker: undefined,
      loginVisible: false,
      searching: false,
      loginType: undefined,
      done: null,
      collection: false,
      makerInfo: undefined,
      view: undefined,
      location: "上海",
      massMarkStyle: [],
      geocoder: undefined,
      massMarks: undefined,
      posPicker: undefined,
      origin: undefined,
    };
  },
  computed: {
    sourceFilter() {
      let arr = this.source || [];
      if (arr.length > 6) {
        return arr.slice(0, 6);
      }
      return arr;
    },
    otherSource() {
      let arr = this.source || [];
      if (arr.length > 6) {
        return arr.slice(6, arr.length);
      }
      return arr;
    },
    mobileType() {
      let query = this.$route.query;
      if (query.mobileType && query.mobileType === "list") {
        return "list";
      } else {
        return undefined;
      }
    },
    keywordClean() {
      return !!this.keyword;
    },
    isMobile() {
      return this.$store.state.isMobile;
    },
    user() {
      return !!this.$store.state.userInfo;
    },
  },
  watch: {
    "$route.query": function (params) {
      if (
        (!params.mobileType || params.mobileType !== "list") &&
        this.isMobile
      ) {
        this.loading = true;
        this.initMark();
      }
    },
  },
  methods: {
    updateMyCollectionState(val) {
      if (val) {
        this.getMyCollections();
      } else {
        this.refresh();
      }
    },
    tagText(item) {
      return tagText(item);
    },
    tagType(item) {
      return tagType(item);
    },
    async updateLatLng(list, params) {
      if (!list || !list.length) {
        return;
      }
      const data = await this.$ajax.put(`v2/houses-lat-lng`, list);
      setTimeout(() => {
        this.housesRefresh(params);
      }, 2000);
    },
    selectSource(source) {
      if (this.loading) {
        return;
      }
      if (this.form.source === source) {
        return;
      }
      this.form.source = source;
      this.refresh();
    },
    resetFilter() {
      this.form = {
        rentType: undefined,
        fromPrice: undefined,
        toPrice: undefined,
        source: "",
      };
      this.refresh();
    },
    async cityChange(cityName) {
      const data = await this.$ajax.get(`v2/cities/${cityName}`);
      this.source = data.data;
      this.form.source = "";
    },
    removeKeyword(item) {
      this.keywordArr.splice(this.keywordArr.indexOf(item), 1);
      this.refresh();
    },
    transformParams() {
      let params = Object.assign({}, this.form);
      if (this.keywordArr.length) {
        params.keyword = this.keywordArr.join(",");
      } else {
        params.keyword = undefined;
      }
      params.city = this.location;
      return params;
    },
    refresh(q) {
      if (this.loading) {
        return;
      }
      let q2 = {};
      if (typeof q === "object") {
        q2 = q;
      }
      let query = this.$route.query;
      let params = Object.assign({}, query, this.transformParams(), q2);
      this.$router.push({ query: params });

      setTimeout(() => {
        this.initMark();
      }, 200);
    },
    cityLocation(item) {
      if (this.loading) {
        return;
      }
      this.location = item;
      this.cityChange(item);

      this.activeCityName = this.cityName = item;
      this.geocoder.setCity(item);
      this.initCenter(this.posPicker, this.geocoder, this);
      this.initMap();
      this.refresh();
    },
    keywordConfirm() {
      let inputValue = this.keywordTag;
      if (inputValue) {
        let has = this.keywordArr.find((item) => {
          return item === inputValue;
        });
        if (!has) {
          this.keywordArr.push(inputValue);
        }
      }
      this.inputVisible = false;
      this.keywordTag = "";
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    changeQuery(q) {
      const query = this.$route.query;
      const params = Object.assign({}, query, q);
      this.$router.push({
        query: params,
      });
    },
    toMap() {
      this.view = undefined;
      this.changeQuery({
        mobileType: undefined,
      });
      this.inMap = false;
    },
    async toList() {
      let com = require("./../components/mobile/house-list").default;
      try {
        let params = {
          ...this.$route.query,
          city: this.cityName,
          houseCount: 180,
          page: 1,
        };
        await asyncComponent(
          com,
          {
            props: {
              _houseList: this.houseList,
              inMap: true,
              params,
            },
          },
          (template) => {
            this.inMap = true;
            this.view = template;
            this.changeQuery({
              mobileType: "list",
            });
          }
        );
        this.view = undefined;
        this.inMap = false;
        this.changeQuery({
          mobileType: undefined,
        });
      } catch (e) {
        this.view = undefined;
        this.inMap = false;
        this.changeQuery({
          mobileType: undefined,
        });
        return;
      }
    },
    whereAmI() {
      this.positionPicker.start(this.lnglat);
    },
    next() {
      const query = this.$route.query;
      let page = 1;
      if (query.page) {
        page = +query.page + 1;
      }
      const params = Object.assign({}, query, { page });
      this.$router.push({
        query: {
          ...params,
        },
      });
      setTimeout(() => {
        this.refresh();
      }, 0);
    },
    handleMobileBg(e) {
      if (e.target === e.currentTarget) {
        this.makerInfo = undefined;
      }
    },
    async getCities() {
      const data = await this.$ajax.get(
        "v2/cities?fields=id,city,sources&index=0&count=100"
      );
      this.cities = data.data.map((item) => {
        return item.city;
      });
    },
    navTo(item) {
      this.transfer(item.geocodes.location, this.map, this);
      this.makerInfo = undefined;
    },
    async collect(item) {
      let self = this;
      if (!self.user) {
        let com = require("../components/login-dialog").default;
        try {
          await asyncComponent(
            com,
            {
              props: {
                loginVisible: true,
                isMobile: self.isMobile,
              },
            },
            (template) => {
              this.view = template;
            }
          );
          this.view = undefined;
        } catch (e) {
          this.view = undefined;
          return;
        }
      }
      // if (this.collection) {
      //   return;
      // }
      this.collection = true;
      const userId = this.$store.state.userInfo.id;
      const data = await this.$ajax.post(`v2/users/${userId}/collections`, {
        // userId,
        houseID: item.id,
        // source: item.source
      });
      if (gtag) {
        gtag("event", "收藏", {
          event_category: item.title,
          label: item.city,
        });
      }
      this.collection = false;
      this.makerInfo = undefined;
      if (this.isMobile) {
        alert(data.message);
      } else {
        this.$message.success(data.message);
      }
    },
    toggleDialog(key, val, type) {
      if (key === "loginVisible") {
        if (type) {
          this.loginType = type;
        } else {
          this.loginType = undefined;
        }
      }
      this[key] = val || false;
    },
    async preview(item) {
      let self = this;
      let com = require("../components/preview-image").default;
      try {
        await asyncComponent(
          com,
          {
            props: {
              images: item.pictures,
              isMobile: self.isMobile,
            },
          },
          (template) => {
            this.view = template;
          }
        );
        this.view = undefined;
      } catch (e) {
        this.view = undefined;
        return;
      }
    },
    search(type) {
      let self = this;
      self.searching = true;
      self.arrivalRange = new AMap.ArrivalRange();
      self.arrivalRange.search(
        self.lnglat,
        self.times,
        function (status, result) {
          self.map.remove(self.polygons);
          self.polygons = [];
          if (result.bounds) {
            for (var i = 0; i < result.bounds.length; i++) {
              var polygon = new AMap.Polygon({
                fillColor: "#3366FF",
                fillOpacity: "0.4",
                strokeColor: "#00FF00",
                strokeOpacity: "0.5",
                strokeWeight: 1,
              });
              polygon.setPath(result.bounds[i]);
              self.polygons.push(polygon);
            }
            self.map.add(self.polygons);
            self.map.setFitView();
            self.map.setZoomAndCenter(self.isMobile ? 15 : 13, self.lnglat);
            self.searching = false;
            if (gtag && type !== "auto") {
              gtag("event", "出行到达圈查询(地点)", {
                event_category: self.keyword,
              });
              gtag("event", "出行到达圈查询(时间)", {
                event_category: self.times,
              });

              let text = "地铁加公交";
              if (self.waysMethod === "SUBWAY") {
                text = "地铁";
              } else if (self.waysMethod === "") {
                text = "公交";
              }
              gtag("event", "出行到达圈查询(方式)", {
                event_category: text,
              });
            }
          } else {
            // eslint-disable-next-line no-console
            console.log("未知错误");
            // self.$message.error('未知错误');
            self.searching = false;
          }
        },
        {
          policy: self.waysMethod,
        }
      );
    },
    houseListClick(item) {
      if (item.geocodes && item.geocodes.location && item.geocodes.location.lng) {
        this.map.setZoomAndCenter(16, [item.geocodes.location.lng, item.geocodes.location.lat]);
        // this.positionPicker.start(item.geocodes.location)
      }
    },
    toggleRight() {
      this.showRight = !this.showRight;
    },
    async getList(params) {
      let data = await this.$ajax.post("v2/houses", params);
      this.houseList = data.data;
      return data;
    },
    transfer(position, map, self) {
      if (this.transferFn) {
        this.transferFn.clear();
      }
      this.transferFn = new AMap.Transfer({
        hideMarkers: false,
        city: this.cityName, // 必须值，搭乘公交所在城市
        map: map, // 可选值，搜索结果的标注、线路等均会自动添加到此地图上
        panel: "panel", // 可选值，显示搜索列表的容器,
        extensions: "all", // 可选值，详细信息
        poliy: AMap.TransferPolicy.LEAST_DISTANCE, // 驾驶策略：最省时模式
      });

      this.transferFn.search(
        new AMap.LngLat(this.myPosition.lng, this.myPosition.lat),
        new AMap.LngLat(position[0], position[1]),
        function (status, result) {
          self.transferWays = true;
          let panelHandle = document.querySelector(".panel-handle");
          self.toggleUp = false;
          if (!panelHandle) {
            const panelComponent = Vue.extend({
              render(h) {
                return h(
                  "span",
                  {
                    class: ["panel-handle"],
                    on: {
                      click() {
                        self.toggleUp = !self.toggleUp;
                      },
                    },
                  },
                  !self.toggleUp ? "收起" : "展开"
                );
              },
            });

            const component = new panelComponent().$mount();
            document.querySelector(`#panel`).appendChild(component.$el);
          }
        }
      );
    },
    installAmapUI(map, self) {
      return new Promise((resolve, reject) => {
        AMapUI.loadUI(["misc/PositionPicker"], function (PositionPicker) {
          let positionPicker = new PositionPicker({
            mode: "dragMarker", //设定为拖拽地图模式，可选'dragMap'、'dragMarker'，默认为'dragMap'
            zIndex: 100000000,
            iconStyle: {
              //自定义外观
              url: "//webapi.amap.com/ui/1.0/assets/position-picker.png", //图片地址
              size: [54, 54], //要显示的点大小，将缩放图片
              ancher: [24, 40], //锚点的位置，即被size缩放之后，图片的什么位置作为选中的位置
            },
            map: map, //依赖地图对象
          });
          positionPicker.on("success", function (positionResult) {
            self.myPosition = positionResult.position;
            self.positionPicker = positionPicker;
            var lngLat = new AMap.LngLat(positionResult.position.lng, positionResult.position.lat);
            self.lnglat = lngLat;
            self.keyword = positionResult.address;
          });

          // positionPicker.start();

          resolve(positionPicker);
        });
      });
    },
    installPlugin(map, self) {
      return new Promise((resolve, reject) => {
        AMap.plugin(
          [
            "AMap.ToolBar",
            "AMap.Driving",
            "AMap.LineSearch",
            `AMap.StationSearch`,
            "AMap.Transfer",
            "AMap.Walking",
            "AMap.Riding",
            "AMap.Geolocation",
            "AMap.AutoComplete",
            "AMap.PlaceSearch",
          ],
          function () {
            //异步同时加载多个插件
            let toolbar = new AMap.ToolBar();
            map.addControl(toolbar);

            let options = {
              showMarker: false, //是否显示定位按钮
            };

            resolve();

            // let geolocation = new AMap.Geolocation(options);
            // map.addControl(geolocation);
            // geolocation.getCurrentPosition((status, result) => {
            //     if (status === 'complete') {
            //         self.myPosition = result.position;
            //         let marker = new AMap.Marker({ //添加自定义点标记
            //             map: map,
            //             zIndex: 100000,
            //             position: [result.position.lng, result.position.lat], //基点位置
            //             offset: new AMap.Pixel(-17, -42), //相对于基点的偏移位置
            //             draggable: true,  //是否可拖动
            //             content: '<div class="marker-route marker-marker-bus-from"></div>'   //自定义点标记覆盖物内容
            //         });
            //         marker.on('dragend', function (ev) {
            //             self.myPosition = ev.lnglat;
            //         })
            //     }
            // });
          }
        );
      });
    },
    getActiveCityName(self) {
      return new Promise((resolve, reject) => {
        let citysearch = new AMap.CitySearch();
        citysearch.getLocalCity(function (status, result) {
          if (status === "complete" && result.info === "OK") {
            if (result && result.city && result.bounds) {
              let cityinfo = result.city;
              let citybounds = result.bounds;
              resolve(cityinfo);
            }
          } else {
            this.$message.error(result.info);
          }
        });
      });
    },
    getLocation(code, item) {
      return new Promise((resolve, reject) => {
        let location = this.stripscript(item.location);
        code.getLocation(location, (status, result) => {
          resolve({
            status,
            result,
          });
        });
      });
    },
    stripscript(str) {
      if (str) {
        var pattern = new RegExp(
          "[`~!@#$^&*()=|{}':;',\\[\\].<>/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？]"
        );
        var rs = "";
        for (var i = 0; i < str.length; i++) {
          rs = rs + str.substr(i, 1).replace(pattern, "");
        }
        return rs;
      }
      return "";
    },
    addMaker(map, data, code, self, massMarkStyle) {
      return new Promise(async (resolve, reject) => {
        let list = await Promise.all(
          data.map(function (item) {
            return new Promise(async (resolve, reject) => {
              if (!item) {
                resolve(item);
              }
              try {
                let status = undefined;
                let result = undefined;
                let update = false;

                if (item.latitude && item.longitude) {
                  status = "complete";
                  result = {
                    info: "ok",
                    geocodes: [
                      {
                        location: {
                          lng: +item.longitude,
                          lat: +item.latitude,
                          O: +item.latitude,
                          P: +item.longitude,
                        },
                      },
                    ],
                  };
                  update = false;
                } else {
                  // let location = await self.getLocation(code, item);
                  // status = location.status;
                  // result = location.result;
                  // update = true;
                }

                if (
                  status === "complete" &&
                  result.info &&
                  result.info.toLocaleLowerCase() === "ok"
                ) {
                  let style = 1;
                  if (item.icon) {
                    style = massMarkStyle.findIndex((s) => {
                      return item.icon.indexOf(s.type) !== -1;
                    });
                  }
                  let title = item.title;
                  if (!title) {
                    title = item.location;
                  }
                  let displayMoney =
                    item.price > 0 ? "租金：" + item.price : "";

                  let sourceContent = item.source
                    ? " 来源：" + item.source
                    : "";

                  let params = {
                    ...item,
                    displayMoney,
                    sourceContent,
                    title,
                    geocodes: result.geocodes[0],
                  };

                  self.mapHouseList.push(params);

                  let marker = {
                    lnglat: [
                      result.geocodes[0].location.lng,
                      result.geocodes[0].location.lat,
                    ],
                    style,
                    name: item.title,
                    item,
                    displayMoney,
                    sourceContent,
                    title,
                    params,
                    update,
                  };

                  resolve(marker);
                } else {
                  resolve(item);
                  //reject(new Error('找不到坐标'))
                }
                // code.getLocation(item.location, (status, result) => {
                // })
              } catch (e) {
                // eslint-disable-next-line no-console
                console.log(e);
                reject(item);
                throw e;
              }
            });
          })
        );
        resolve(list);
      });
    },
    keywordSelect(map, positionPicker) {
      let autocomplete = new AMap.AutoComplete({
        input: "keyword",
      });
      let placeSearch = new AMap.PlaceSearch({
        map: map,
      });
      let self = this;
      autocomplete.on('select', selectChange);
      // 废弃方法 AMap.event.addListener(autocomplete, "select", select); //注册监听，当选中某条记录时会触发
      function selectChange(e) {
        positionPicker.start(e.poi.location);
        self.lnglat = e.poi.location;
        if (self.isMobile) {
          self.search();
        }
        // placeSearch.setCity(e.poi.adcode);
        // placeSearch.search(e.poi.name);  //关键字查询查询
      }
    },
    getCityCenter(positionPicker, code, self, name, cb) {
      let location = undefined;
      return new Promise((resolve, reject) => {
        code.getLocation(name, (status, result) => {
          // 城市中心点
          if (status === "complete" && result.info === "OK") {
            location = result.geocodes[0].location;
            positionPicker.start(location);
            self.lnglat = AMap.LngLat(location.lng, location.lat);
            // self.keyword = result.geocodes[0].formattedAddress;
          } else {
            if (cb) {
              cb();
            } else {
              location = self.map.getBounds().getSouthWest();
              self.lnglat = new AMap.LngLat(location.lng, location.lat);
              // self.keyword = self.cityName;
              positionPicker.start(location);
            }
          }
          resolve();
        });
      });
    },

    async init(location) {
      // const loading = this.$loading({
      //   lock: true,
      //   text: '正在加载数据,若等待时间过长,请重新刷新页面',
      //   spinner: 'el-icon-loading',
      //   background: 'rgba(0, 0, 0, 0.7)'
      // });
      try {
        const query = this.$route.query;
        let cityName = query.city;
        if (!cityName) {
          cityName = await this.getActiveCityName(this);
        }
        if (location) {
          this.activeCityName = this.cityName = location;
        } else {
          this.activeCityName = this.cityName = cityName;
        }

        this.mapHouseList = [];
        let map = new AMap.Map("map-container", {
          zoom: this.zoom,
          resizeEnable: true,
        });
        this.map = map;
        map.clearMap();
        map.setCity(this.cityName);
        let self = this;

        await this.installPlugin(map, self);
        this.posPicker = await this.installAmapUI(map, self);
        let positionPicker = this.posPicker;

        this.geocoder = new AMap.Geocoder({
          city: this.cityName,
          radius: 1000,
        });

        let code = this.geocoder;

        this.initCenter(positionPicker, code, self);

        this.keywordSelect(map, positionPicker);

        this.massMarkStyle = [
          {
            url: require("./../images/Black.png"),
            anchor: new AMap.Pixel(3, 3),
            size: new AMap.Size(19, 30),
            type: "Black",
          },
          {
            url: require("./../images/Blue.png"),
            anchor: new AMap.Pixel(3, 3),
            size: new AMap.Size(19, 30),
            type: "Blue",
          },
          {
            url: require("./../images/LightGreen.png"),
            anchor: new AMap.Pixel(3, 3),
            size: new AMap.Size(19, 30),
            type: "LightGreen",
          },
          {
            url: require("./../images/OrangeYellow.png"),
            anchor: new AMap.Pixel(3, 3),
            size: new AMap.Size(19, 30),
            type: "OrangeYellow",
          },
          {
            url: require("./../images/PaleGreen.png"),
            anchor: new AMap.Pixel(3, 3),
            size: new AMap.Size(19, 30),
            type: "PaleGreen",
          },
          {
            url: require("./../images/PaleRed.png"),
            anchor: new AMap.Pixel(3, 3),
            size: new AMap.Size(19, 30),
            type: "PaleRed",
          },
          {
            url: require("./../images/PaleYellow.png"),
            anchor: new AMap.Pixel(3, 3),
            size: new AMap.Size(19, 30),
            type: "PaleYellow",
          },
          {
            url: require("./../images/Pink.png"),
            anchor: new AMap.Pixel(3, 3),
            size: new AMap.Size(19, 30),
            type: "Pink",
          },
          {
            url: require("./../images/Red.png"),
            anchor: new AMap.Pixel(3, 3),
            size: new AMap.Size(19, 30),
            type: "Red",
          },
          {
            url: require("./../images/Violet.png"),
            anchor: new AMap.Pixel(3, 3),
            size: new AMap.Size(19, 30),
            type: "Violet",
          },
        ];
        await this.initMark();

        setTimeout(() => {
          this.search("auto");
        });
        // loading.close();
        this.loading = false;
      } catch (e) {
        this.$message.error("初始化地图失败,请再次刷新");
        throw e;
      }
    },
    changeTitle() {
      let query = this.$route.query;
      let title = `地图搜租房-${query.city}`;
      if (query.source) {
        title += `-${query.source}`;
      }
      document.title = title;
    },
    appendScript(url) {
      return new Promise((resolve) => {
        let jsapi = document.createElement("script");
        jsapi.charset = "utf-8";
        jsapi.src = url;
        document.head.appendChild(jsapi);
        jsapi.onload = () => {
          resolve();
        };
        jsapi.onerror = () => {
          this.$message.error("地图初始化失败,请重新刷新页面");
        };
      });
    },
    async initCenter(positionPicker, code, self) {
      if (
        this.$store.state.userInfo &&
        this.$store.state.userInfo.workAddress
      ) {
        await this.getCityCenter(
          positionPicker,
          code,
          self,
          this.$store.state.userInfo.workAddress,
          async () => {
            await this.getCityCenter(positionPicker, code, self, this.cityName);
          }
        );
      } else {
        await this.getCityCenter(positionPicker, code, self, this.cityName);
      }
    },
    async initMap() {
      this.map.clearMap();
      this.map.setCity(this.cityName);
    },
    async initMark(arrayData = []) {
      return new Promise(async (resolve, reject) => {
        this.loading = true;
        this.getCities();
        this.mapHouseList = [];
        let code = this.geocoder;
        let map = this.map;
        let houseCount = undefined;
        if (this.isMobile) {
          houseCount = 180;
        }
        let params = {
          ...this.$route.query,
          city: this.cityName.replace(/市/gi, ""),
          houseCount,
        };
        delete params.cityname;
        let info = await this.getList(params);
        if (this.mobileType === "list" && this.isMobile) {
          this.toList();
          return;
        }
        let data = info.data;
        if (Array.isArray(arrayData) && arrayData.length) {
          data = arrayData;
        }
        let self = this;

        if (process.env.NODE_ENV === "development") {
          // data.length = 20;
        }
        let massMarkStyle = this.massMarkStyle;
        let newData = await this.addMaker(map, data, code, self, massMarkStyle);

        let dataArr = newData.filter((item) => {
          if (item.lnglat) {
            return item;
          }
        });

        let markers = [];

        // dataArr.forEach(item=>{
        //   markers.push(new AMap.Marker({
        //     position: item['lnglat']
        //   }))
        // });
        let massMarks = undefined;

        if (!this.massMarks) {
          massMarks = new AMap.MassMarks([], {
            zIndex: 120, // 海量点图层叠加的顺序
            zooms: [3, 19], // 在指定地图缩放级别范围内展示海量点图层
            style: massMarkStyle, //多种样式对象的数组
          });
          this.massMarks = massMarks;
        } else {
          massMarks = this.massMarks;
        }
        massMarks.clear();

        // var m = new AMap.Marker({
        //   content: ' ',
        //   map: map
        // });

        massMarks.on("click", function (e) {
          let eData = e.data;
          let item = eData.item;
          let displayMoney = eData.displayMoney;

          let sourceContent = eData.sourceContent;
          let title = eData.title;
          let publishDate = eData.publishDate;

          if (self.isMobile) {
            self.makerInfo = eData.params;
          } else {
            let infoWindow = new AMap.InfoWindow({
              offset: new AMap.Pixel(5, 0),
              content: ``, //传入 dom 对象，或者 html 字符串
            });
            let rentType = "未知";
            switch (item.rentType) {
              case 1:
                rentType = "合租";
                break;
              case 2:
                rentType = "单间";
                break;
              case 3:
                rentType = "整套出租";
                break;
              case 4:
                rentType = "公寓";
                break;
              default:
                rentType = "未知";
                break;
            }

            const makerInfoComponent = Vue.extend({
              render(h) {
                return h(
                  "div",
                  {
                    class: ["marker-info"],
                  },
                  [
                    h("a", {
                      attrs: {
                        target: "_blank",
                        href: `${self.origin}#/detail/${item.id}?onlineURL=${item.onlineURL
                          }`,
                      },
                      class: ["marker-link"],
                      domProps: {
                        innerHTML: `房源: ${title}`,
                      },
                    }),
                    h("a", {
                      attrs: {
                        target: "_blank",
                        href: `${self.origin}#/detail/${item.id}?onlineURL=${item.onlineURL
                          }`,
                      },
                      class: ["marker-link"],
                      domProps: {
                        innerHTML: `发布时间: ${item.publishDate}`,
                      },
                    }),
                    h("a", {
                      attrs: {
                        target: "_blank",
                        href: `${self.origin}/#/detail/${item.id}?onlineURL=${item.onlineURL
                          }`,
                      },
                      class: ["marker-link"],
                      domProps: {
                        innerHTML: `${displayMoney}`,
                      },
                    }),
                    h("a", {
                      attrs: {
                        target: "_blank",
                        href: `${self.origin}#/Map?city=${item.city}&source=${item.source
                          }&rentType=${item.rentType}`,
                      },
                      class: ["marker-link"],
                      domProps: {
                        innerHTML: `类型: ${rentType}`,
                      },
                    }),
                    h("a", {
                      attrs: {
                        target: "_blank",
                        href: `${self.origin}#/Map?city=${item.city}&source=${item.source
                          }`,
                      },
                      class: ["marker-link"],
                      domProps: {
                        innerHTML: `${sourceContent}`,
                      },
                    }),
                    h(
                      "span",
                      {
                        style: {
                          display:
                            item.pictures && item.pictures.length
                              ? "block"
                              : "none",
                        },
                        class: ["marker-info", "marker-link"],
                        on: {
                          click: async function (e) {
                            self.preview(item);
                          },
                        },
                      },
                      [
                        h("i", {
                          class: ["el-icon-picture"],
                        }),
                        "查看图片",
                      ]
                    ),
                    h(
                      "span",
                      {
                        class: ["marker-info", "marker-link"],
                        on: {
                          click: async function (e) {
                            self.collect(item);
                          },
                        },
                      },
                      [
                        h("i", {
                          class: ["el-icon-star-on"],
                        }),
                        "收藏",
                      ]
                    ),
                    h(
                      "span",
                      {
                        class: ["marker-info", "marker-link"],
                        on: {
                          click: function (e) {
                            self.transfer(eData.lnglat, map, self);
                            infoWindow.close();
                          },
                        },
                      },
                      [
                        h("i", {
                          class: ["el-icon-location"],
                        }),
                        "开始导航",
                      ]
                    ),
                  ]
                );
              },
            });

            const component = new makerInfoComponent().$mount();

            infoWindow.setContent(component.$el);
            infoWindow.open(map, eData.lnglat);
          }
        });

        massMarks.setMap(map);
        massMarks.setData(dataArr);

        // new AMap.MarkerClusterer(map, markers, {gridSize: 100});

        dataArr = dataArr.filter((item) => {
          return item.update;
        });
        let updateList = dataArr.map((item) => {
          return {
            id: item.item.id,
            longitude: item.lnglat.lng,
            latitude: item.lnglat.lat,
            source: item.item.source,
            onlineURL: item.item.onlineURL,
            city: item.item.city,
          };
        });
        this.updateLatLng(updateList, params);
        setTimeout(() => {
          this.search("auto");
        });
        this.loading = false;
        this.changeTitle();
        resolve();
      });
    },
    async housesRefresh(params) {
      const data = await this.$ajax.post(`v2/houses-refresh`, params);
    },
    async getMyCollections() {
      const userId = this.$store.state.userInfo.id;
      const data = await this.$ajax.get(`v2/users/${userId}/collections`);
      if (Array.isArray(data.data) && data.data.length) {
        this.initMark(data.data);
      }
    },
  },
  async created() {
    let query = this.$route.query;
    let keyword = query.keyword;
    if (keyword) {
      this.keywordArr = keyword.split(",");
    }
    let { origin, pathname } = window.location;
    this.origin = origin + pathname;
  },
  async mounted() {
    this.loading = true;

    const query = this.$route.query;
    let cityName = query.city;
    if (cityName) {
      this.location = cityName;
      this.cityChange(cityName);
    } else {

      this.$router.replace({ query: { city: "上海" } });
      window.location.reload();
      return;

    }

    let key = `8b942f01c2c6b908b8594f86c07c1725`;
    let plugin = `AMap.ArrivalRange,AMap.Scale,AMap.Geocoder,AMap.Transfer,AMap.AutoComplete,AMap.CitySearch,AMap.Walking,AMap.MarkerClusterer`.split();
    plugin.push(`AMap.ToolBar`);
    let url = `https://webapi.amap.com/maps?v=2.0&key=${key}&plugin=${plugin.join()}`;

    userInfo(this);
    await this.appendScript(url);
    await this.appendScript(`//webapi.amap.com/ui/1.1/main.js?v=1.1.1`);
    //await this.appendScript(`//cache.amap.com/lbs/static/addToolbar.js`);

    gtag("event", "进入地图页");
    this.init();
  },
};
</script>
